import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  summarySection: {
    flexGrow: 1,
    width: "24rem",
    position: "sticky",
    top: "3rem",
    alignSelf: "start",
  },
  summaryInner: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: `1px solid ${theme.snowColor}`,
    borderRadius: "10px",
    fontSize: "0.8rem",
    overflow: "hidden",
  },
  summaryCart: {
    padding: "1rem",
    backgroundColor: theme.lighterSnowColor,
  },
  cartItems: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  cartItem: {
    display: "flex",
    gap: "0.7rem",
    padding: "1rem",
    backgroundColor: theme.whiteColor,
    borderRadius: "5px",
  },
  cartItemImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.whiteSmokeColor,
    minWidth: "4rem",
    maxWidth: "4rem",
    height: "4rem",
    objectFit: "cover",
  },
  cartItemInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    fontSize: "0.7rem",
  },
  cartItemBrand: {
    fontWeight: 600,
  },
  cartItemQuantity: {
    textTransform: "uppercase",
  },
  discountCode: {
    display: "flex",
    justifyContent: "space-between",
    gap: "0.5rem",
    padding: "1rem",
    borderBottom: `1px solid ${theme.snowColor}`,
    // '& > form': {
    //   display: 'flex',
    //   justifyContent: 'space-between',
    //   width: '100%',
    // },
    "& input, button": {
      padding: "0.5rem",
      border: `1px solid ${theme.snowColor}`,
      borderRadius: "5px",
      fontSize: "0.8rem",
      fontFamily: theme.fontFamilyArchivo,
    },
    "& input": {
      width: "75%",
    },
    "& button": {
      width: "25%",
      cursor: "pointer",
    },
  },
  summaryTotal: {
    display: "flex",
    flexDirection: "column",
    height: "max-content",
    width: "100%",
    gap: "1rem",
    padding: "1rem",
    textTransform: "uppercase",
    "& > div": {
      display: "flex",
      justifyContent: "space-between",
    },
    "& > div > span:first-child": {
      fontWeight: 500,
    },
  },
  estimatedTotal: {
    fontSize: "0.9rem",
    textTransform: "capitalize",
    "& > span:first-child": {
      fontWeight: 600,
    },
  },
  horizontalLine: {
    height: 0,
    margin: 0,
    padding: 0,
    border: "none",
    borderTop: `1px solid ${theme.snowColor}`,
    color: theme.dimGrayColor,
    "& > legend": {
      margin: "auto",
      padding: "0 1rem",
      textTransform: "uppercase",
    },
  },
}));

export default useStyles;
